module.exports = __webpack_public_path__ + "nfolder_calc.svg";